var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.61 23.286a4.674 4.674 0 000 6.623 4.68 4.68 0 003.325 1.37 4.68 4.68 0 003.326-1.37 4.643 4.643 0 001.378-3.313c0-1.25-.49-2.425-1.378-3.31a4.721 4.721 0 00-6.65 0zm24.235-12.504a3.509 3.509 0 001.04-2.503c0-.946-.368-1.835-1.04-2.504a3.572 3.572 0 00-5.027 0 3.509 3.509 0 00-1.04 2.504c0 .945.368 1.834 1.04 2.503a3.539 3.539 0 002.512 1.037c.95 0 1.843-.37 2.515-1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.761 28.312l2.523-2.512a.677.677 0 000-.965l-3.199-3.187.184-.184a.68.68 0 000-.965 4.719 4.719 0 00-4.204-1.29l-7.788-8.837a7.18 7.18 0 00.307-2.092c0-1.93-.755-3.745-2.124-5.109a7.22 7.22 0 00-5.129-2.115 7.22 7.22 0 00-5.128 2.115 7.164 7.164 0 00-2.096 5.744l-9.167 8.052c-3.149-.646-6.553.245-8.991 2.673-3.852 3.836-3.852 10.078 0 13.912a9.863 9.863 0 006.987 2.88c2.532 0 5.06-.959 6.988-2.88a9.807 9.807 0 002.682-8.949l8.085-9.13a7.293 7.293 0 002.743-.279l8.873 7.756a4.675 4.675 0 001.297 4.186.682.682 0 00.969 0l.208-.206 3.201 3.185a.685.685 0 00.969 0l1.838-1.83m.362-.373l2.788 2.776m-3.856-9.041L42.79 26.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.c714539aba4b2abc55c1354794859e2d.svg";
export { ForwardRef as ReactComponent };